import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { GiuliaTeaser } from "@/components/GiuliaTeaser";

// Page d'APERÇU uniquement (pas de smooth-scroll Lenis) pour visualiser
// le hero appliqué + le teaser Giulia. Non liée dans la navigation.
export default function HeroPreviewPage() {
  return (
    <div className="relative min-h-screen bg-ink text-slate-50 antialiased">
      <div className="grain" aria-hidden="true" />
      <div className="fixed top-16 inset-x-0 z-40 text-center py-1.5 text-[11px] font-mono-ui uppercase tracking-widest text-amber-300 bg-amber-400/10 border-y border-amber-400/30">
        Aperçu — maquette non publiée
      </div>
      <Nav onTip={() => {}} />
      <main>
        <Hero onQuote={() => {}} />
        <GiuliaTeaser />
      </main>
    </div>
  );
}
